import Vue from "vue";
import Vuex from "vuex";

import { auth } from "./auth.module";
import { search } from "./search.module";
import { ui } from "./ui.module";

Vue.use(Vuex);

export const store = new Vuex.Store({
  modules: {
    auth,
    search,
    ui
  }
});

export default store;